import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/report_payrolls/v1`;

export function getPayrollForBank({ date, period, search, isExport = false }) {
    search = search ? search : "";
    const result = axios({
        method: 'GET',
        headers: getHeaders(),
        url: `${url}/payroll_for_bank?date=${date}&period=${period}&search=${search}&isExport=${isExport}`
    });
    return new Promise((resolve, reject) => {
        result
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
}

export function getPayrollForNSSF({ date, search, isExport = false }) {
    search = search ? search : "";
    const result = axios({
        method: 'GET',
        headers: getHeaders(),
        url: `${url}/payroll_for_nssf?date=${date}&search=${search}&isExport=${isExport}`
    });
    return new Promise((resolve, reject) => {
        result
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
}

export function getPayrollForTax({ date, search, isExport = false }) {
    search = search ? search : "";
    const result = axios({
        method: 'GET',
        headers: getHeaders(),
        url: `${url}/payroll_for_tax?date=${date}&search=${search}&isExport=${isExport}`
    });
    return new Promise((resolve, reject) => {
        result
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
}

export function getPayrolls({ startMonth, endMonth, payrollPeriod = "", search = "", isExport = false, payrollElements = null }) {
    let newUrl = `${url}/payrolls?search=${search}${(startMonth && endMonth) ? `&startMonth=${startMonth}&endMonth=${endMonth}` : ""}&isExport=${isExport}&payrollPeriod=${payrollPeriod}`;
    if (payrollElements) newUrl += `&payrollElements=[${payrollElements}]`;
    const result = axios({
        method: 'GET',
        headers: getHeaders(),
        url: newUrl,
    });
    return new Promise((resolve, reject) => {
        result
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
}

export function getCostSharing({ date, payrollPeriod = "", search = "", isExport = false }) {
    const result = axios({
        method: 'GET',
        headers: getHeaders(),
        url: `${url}/cost_sharing?search=${search}&date=${date}&payrollPeriod=${payrollPeriod}&isExport=${isExport}`
    });
    return new Promise((resolve, reject) => {
        result
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
}

export function getPayrollForAgresso({ date, type = "", search = "", isExport = false }) {
    const result = axios({
        method: 'GET',
        headers: getHeaders(),
        url: `${url}/payroll_for_agresso?search=${search}&date=${date}&type=${type}&isExport=${isExport}`
    });
    return new Promise((resolve, reject) => {
        result
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
}

export function getAllocationProvidentFund({ date, search = "", isExport = false }) {
    const result = axios({
        method: 'GET',
        headers: getHeaders(),
        url: `${url}/allocation_provident_fund?search=${search}&date=${date}&isExport=${isExport}`
    });
    return new Promise((resolve, reject) => {
        result
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
}

export function getAllocation13thMonthSalary({ date, search = "", isExport = false }) {
    const result = axios({
        method: 'GET',
        headers: getHeaders(),
        url: `${url}/allocation_annual_salary?search=${search}&date=${date}&isExport=${isExport}`
    });
    return new Promise((resolve, reject) => {
        result
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
}

export function getAllocationSeniorityAndSeverancePay({ date, search = "", isExport = false }) {
    const result = axios({
        method: 'GET',
        headers: getHeaders(),
        url: `${url}/allocation_seniority?search=${search}&date=${date}&isExport=${isExport}`
    });
    return new Promise((resolve, reject) => {
        result
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
}

export function getSeniorityResigned({ date, search = "", isExport = false, seniorityType = "first-seniority" }) {
    const result = axios({
        method: 'GET',
        headers: getHeaders(),
        url: `${getURl()}/payroll/v1/get-payment-resign?employee-name=${search}&year=${date}&seniority-type=${seniorityType}&is-export=${isExport}`
    });
    return new Promise((resolve, reject) => {
        result
            .then(response => {
                return resolve(response.data)
            })
            .catch(error => reject(error));
    });
}

export function getSeniorityResignedExcel({ date, search = "", isExport = false, seniorityType = "first-seniority" }) {
    const result = fetch(`${getURl()}/payroll/v1/get-payment-resign?employee-name=${search}&year=${date}&seniority-type=${seniorityType}&is-export=${isExport}`,{
        method: 'GET',
        headers: getHeaders(),
    });
    return result;
}


